import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { FinderManagementContent } from './Components/FinderManagementContent';
import { NotificationStrategyProvider } from 'src/ZoneManagement/Providers/NotificationStrategyProvider';

export const FinderManagement = (): React.JSX.Element => (
  <Page title="Finders" accessKey={'finders'} isSearchable={true}>
    <NotificationStrategyProvider>
      <FinderManagementContent />
    </NotificationStrategyProvider>
  </Page>
);
